import React, { useState } from 'react'
import Content from 'blocks.app/content/content'
import Catalog from 'blocks.app/catalog/catalog'
import { checkAvailableModule } from '../../../core/helpers/routes/routes'
import {
    LENS_OF_TIME_CATALOG_CONFIG,
    LENS_OF_TIME_CATALOG_TYPE,
    LensOfTimeSelectedItems,
} from './InstancesCatalogLensOfTime-types'

const InstancesCatalogLensOfTimeComponent = () => {
    const [selectedItems, setSelectedItems] = useState<LensOfTimeSelectedItems>([])

    return (
        <Content title={LENS_OF_TIME_CATALOG_TYPE}>
            <Catalog
                allowEmptyList={LENS_OF_TIME_CATALOG_CONFIG.allowEmptyList}
                type={LENS_OF_TIME_CATALOG_CONFIG.type}
                onSelect={setSelectedItems}
                selectedItems={selectedItems}
                treeView={LENS_OF_TIME_CATALOG_CONFIG.treeView}
                additionalData={LENS_OF_TIME_CATALOG_CONFIG.additionalData}
                fixedHeader={LENS_OF_TIME_CATALOG_CONFIG.fixedHeader}
                isExistRightToolbar={LENS_OF_TIME_CATALOG_CONFIG.isExistRightToolbar}
                hideHeader={LENS_OF_TIME_CATALOG_CONFIG.hideHeader}
            />
        </Content>
    )
}

export const InstancesCatalogLensOfTime = checkAvailableModule('instancesCatalog/lensOfTime')
    ? InstancesCatalogLensOfTimeComponent
    : null
